import { UserModel } from "../../../models/User";

export interface userStateInterface {
  users: UserModel[];
  selectedUser: {
    id: string;
    jerryCanRedeem: Date | undefined;
  };
  lastCursor: string | Date;
  loading: boolean;
}

const initState: userStateInterface = {
  users: [],
  selectedUser: {
    id: "",
    jerryCanRedeem: undefined,
  },
  lastCursor: "",
  loading: false,
};

const userReducer: any = (state = initState, action: any) => {
  switch (action.type) {
    case "UPDATE_USER_LIST":
      return {
        ...state,
        users: action.payload.users,
        lastCursor: action.payload.lastCursor,
      };
    case "UPDATE_SELECTED_USER":
      return {
        ...state,
        selectedUser: action.payload.selectedUser,
      };
    case "UPDATE_USER_LOADING":
      return {
        ...state,
        loading: action.payload.loading,
      };
    default:
      return state;
  }
};

export default userReducer;
